// extracted by mini-css-extract-plugin
export default {"component":"RedirectButtons__component--slots-sixHr","wrapper":"RedirectButtons__wrapper--slots-QO7zk"};